import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-foreground-800">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                鸭王<span className="text-accent-500">在线观看</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-700">
              专注为电影爱好者提供最新影视资源的分类浏览与在线观看体验，类型丰富、更新及时、操作简便。
            </p>
          </div>

          <div>
            <p className="mb-4 text-sm font-semibold text-foreground-950">热门分类</p>
            <ul className="grid grid-cols-2 gap-y-2 text-sm">
              {genres.slice(0, 8).map((g) => (
                <li key={g.slug}>
                  <Link
                    to={`/category/${g.slug}`}
                    className="text-foreground-700 transition-colors hover:text-accent-500"
                  >
                    {g.name}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-4 text-sm font-semibold text-foreground-950">网站导航</p>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-700 transition-colors hover:text-accent-500">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-foreground-700 transition-colors hover:text-accent-500">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-700 transition-colors hover:text-accent-500">
                  搜索影片
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-700 transition-colors hover:text-accent-500">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="mb-4 text-sm font-semibold text-foreground-950">联系我们</p>
            <ul className="flex flex-col gap-2 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-500"></i>
                support@yawang-demo.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-accent-500"></i>
                每日 09:00 - 23:00 更新资源
              </li>
              <li className="mt-1 text-xs text-foreground-600">
                本站为内容演示站点，播放与分享功能为演示状态。
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/30">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-600 sm:flex-row md:px-6">
          <p>© 2026 鸭王在线观看 · 本站所有影片资料均为演示数据</p>
          <p className="flex items-center gap-4">
            <span>仅供学习演示，不提供真实播放</span>
          </p>
        </div>
      </div>
    </footer>
  );
}